/* v2-quick-select.js - shows the real new product form (product.quick-select) inside the Shop the Look drawers.
   Shopify does not allow storefront pages in an iframe (X-Frame-Options: DENY), so the main product section is fetched,
   inserted into the drawer and the same v2 scripts the product page uses are run on it. That way piece/fit choices,
   line properties, pricing and add-to-cart behave exactly like the product page.
   window.V2QuickSelect.mount(handle, box) -> Promise; rejects when it cannot load (caller then shows the old form). */
(function () {
  if (window.V2QuickSelect) return;
  function base(u) { return String(u || '').split('?')[0].split('/').pop(); }
  function haveScript(name) {
    return Array.prototype.some.call(document.querySelectorAll('script[src]'), function (s) { return base(s.getAttribute('src')) === name; });
  }
  function haveCss(name) {
    return Array.prototype.some.call(document.querySelectorAll('link[rel="stylesheet"]'), function (l) { return base(l.getAttribute('href')) === name; });
  }
  function runScript(o) {
    return new Promise(function (resolve) {
      var s = document.createElement('script');
      if (o.src) { s.src = o.src; s.onload = resolve; s.onerror = resolve; } else { s.textContent = o.text; }
      document.body.appendChild(s);
      if (!o.src) resolve();
    });
  }
  function mount(handle, box) {
    return fetch('/products/' + encodeURIComponent(handle) + '?view=quick-select', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('load ' + r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var sec = doc.querySelector('main .shopify-section');
        if (!sec || !sec.querySelector('[data-v2-groups]')) throw new Error('no v2 form');
        var other = document.querySelector('[data-v2-groups]');
        if (other && !box.contains(other)) throw new Error('v2 form already on page');
        Array.prototype.forEach.call(doc.querySelectorAll('link[rel="stylesheet"]'), function (l) {
          if (!haveCss(base(l.getAttribute('href')))) {
            var c = document.createElement('link'); c.rel = 'stylesheet'; c.href = l.href; document.head.appendChild(c);
          }
        });
        /* only real JavaScript is re-run; data blocks (type="application/json", variant data etc.) stay in place */
        function isJs(s) { var t = (s.getAttribute('type') || '').toLowerCase(); return !t || t === 'text/javascript' || t === 'application/javascript' || t === 'module'; }
        var inline = [];
        Array.prototype.forEach.call(sec.querySelectorAll('script'), function (s) {
          if (!isJs(s)) return;
          inline.push({ src: s.getAttribute('src') ? s.src : '', text: s.textContent });
          s.parentNode.removeChild(s);
        });
        box.innerHTML = '';
        box.appendChild(document.importNode(sec, true));
        var chain = Promise.resolve();
        /* The section carries its own script tags (v2-groups.js, product-form.js ...). Run them in order: a file the page
           already has is skipped, except v2-groups.js, which is started again instead (each run retires the previous
           one, see V2RUN in v2-groups.js), so every open gets a working form. */
        inline.forEach(function (o) {
          chain = chain.then(function () {
            if (!o.src) return runScript(o);
            var n = base(o.src);
            if (n === 'v2-groups.js' && typeof window.__v2GroupsReinit === 'function') { window.__v2GroupsReinit(); return; }
            if (n !== 'v2-groups.js' && haveScript(n)) return;
            return runScript(o);
          });
        });
        return chain;
      })
      .then(function () {
        return new Promise(function (resolve, reject) {
          var t0 = Date.now();
          (function wait() {
            var g = box.querySelector('[data-v2-groups]');
            if (g && g.getAttribute('data-v2-ready')) return resolve();
            if (Date.now() - t0 > 8000) return reject(new Error('v2 form did not start'));
            setTimeout(wait, 100);
          })();
        });
      });
  }
  window.V2QuickSelect = { mount: mount };
})();
